import { render, staticRenderFns } from "./AnalysesList.vue?vue&type=template&id=fff09f54&scoped=true&"
import script from "./AnalysesList.vue?vue&type=script&lang=ts&"
export * from "./AnalysesList.vue?vue&type=script&lang=ts&"
import style0 from "./analyses-list.scss?vue&type=style&index=0&id=fff09f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff09f54",
  null
  
)

export default component.exports